import React, { useEffect, useRef, useState } from 'react'

const Loader = ({ loading }) => {
    const [progress, setProgress] = useState(0);
    const [finished, setFinished] = useState(false);
    const [visible, setVisible] = useState(false);
    const intervalRef = useRef(null);
    const timeoutRef = useRef(null);
    const hasStartedRef = useRef(false);
    const hideTimeoutRef = useRef(null);

    useEffect(() => {
        if (loading && !hasStartedRef.current) {
            hasStartedRef.current = true;
            startProgress();
        }

        return () => {
            clearInterval(intervalRef.current);
        };
    }, [loading]);

    const startProgress = () => {
        setProgress(0);
        setFinished(false);
        setVisible(true);

        intervalRef.current = setInterval(() => {
            setProgress((prev) => (prev < 90 ? prev + (100 - prev) * 0.1 : prev));
        }, 100);

        timeoutRef.current = setTimeout(() => {
            finishProgress();
        }, 1000);
    };

    const finishProgress = () => {
        clearInterval(intervalRef.current);
        setProgress(100);
        setFinished(true);

        hideTimeoutRef.current = setTimeout(() => {
            setVisible(false);
            setProgress(0)
            setFinished(true);
            hasStartedRef.current = false;
        }, 500);
    };

    if (!visible) return null

    return (
        <div className='loader-container'>
            <div className='background' />
            <div className={`fill  ${finished ? 'finished' : ''}`}
                style={{ width: `${progress}%` }} />
        </div>
    )
}
export default Loader